import React from 'react';
import './App.css';
import { ReactSVG } from 'react-svg';
import moment from 'moment/moment';
import 'moment-timezone';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { apiUrl, crossOrigin, webSocket, WelcomeTexts, CONTINUE, END_CHAT, selectDateMsg, noSlotsMsg, BackToCalendar, IntervalMessages, idleMessage, imagesPath, logo, logoWhite, loader } from './config';
import ReactHtmlParser, { processNodes, convertNodeToElement, htmlparser2 } from 'react-html-parser';
import axios from 'axios'
let connection;
let staticMessageInterval;
let idleMessageInterval;
let staticMessageIndex = 1;
//var Promise = require('es6-promise').Promise;
var elmnt = document.body.clientWidth;
function resetWidth() {
  elmnt = document.body.clientWidth;
}
window.addEventListener("resize", resetWidth);


function getBase64Image(urlImg, callback) {
  let actionType = 'image/png';
  let type = urlImg.split('.')[urlImg.split('.').length - 1];
  if (type == 'gif' || type == 'GIF' || type == 'Gif') {
    actionType = "image/gif";
  }

  var img = new Image();
  img.crossOrigin = 'Anonymous';
  img.onload = function () {
    var canvas = document.createElement('CANVAS');
    var ctx = canvas.getContext('2d');
    var dataURL;
    canvas.height = this.height;
    canvas.width = this.width;
    ctx.drawImage(this, 0, 0);
    dataURL = canvas.toDataURL(actionType);
    callback(dataURL);
  };
  img.src = urlImg;
};

export default class App extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      //nowDate:new Date(),
      username: '',
      daysname: ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat'],
      startChat: false,
      agentEmail: '',
      timeSend: '',
      chatList: [],
      slots: [],
      message: "",
      logoBase64: '',
      logoWhiteBase64: '',
      loaderBase64: '',
      isDisabled: false,
      inputDisabled: false,
      chatWidth: 330,
      send: "",
      lastSlotType: false,
      date: new Date(),
      topScrollButton: true,
      timeSlotLoader: true,
      bootomScrollButton: false,
      isEnd: false,
      availableSchedule: [],
      includeDates: [],
      timeSlots: [],
      selectedDate: '',
      showTimeSlot: elmnt > 640 ? true : false,
      selectedTime: '',
      // isMinimised: false,
      isPrompt: false
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  setImages = async () => {
    let logoBase64 = await new Promise(async (resolve, reject) => {
      await getBase64Image(require(process.env.REACT_APP_imagesPath + process.env.REACT_APP_logo), function (result) {
        resolve(result);
      });
    });
    let logoWhiteBase64 = await new Promise(async (resolve, reject) => {
      await getBase64Image(require(process.env.REACT_APP_imagesPath + process.env.REACT_APP_logoWhite), function (result) {
        resolve(result);
      });
    });
    let loaderBase64 = loader;
    // await new Promise(async (resolve, reject)=>{
    //   await getBase64Image(require(process.env.REACT_APP_imagesPath+process.env.REACT_APP_loader), function(result){
    //     resolve(result);
    //   });
    // });
    //console.log(logoBase64, logoWhiteBase64);
    this.setState({ logoBase64: logoBase64, logoWhiteBase64: logoWhiteBase64, loaderBase64: loaderBase64 });

  }

  async componentDidMount() {
    this.setImages();
    let checkUser = await localStorage.getItem("user:data") ? JSON.parse(localStorage.getItem("user:data")) : {};
    if (checkUser && checkUser.data === "login") {
      await this.setState({ startChat: true });
      await this.startInit(false);
      // console.log(moment.tz.names());
    } else {
      this.setState({ startChat: false });
    }
    // let days = this.state.daysname[new Date().getDay()+1];
    // console.log(days)
    // let year = this.state.nowDate.getFullYear()
    // let month = this.state.nowDate.getMonth()+1
    // let date = this.state.nowDate.getDate()+1
    // this.tokenCreate(new Date(year+'-'+month+'-'+date), this.state.daysname[new Date().getDay()+1])
  }

  idleMessageset = async (nowFlag) => {

    if (localStorage.getItem('agentAsign') == '1') {
      clearTimeout(idleMessageInterval);
    } else {
      if (nowFlag) {
        const scrollingElement = document.getElementById("scroll-chat");
        const { message, username, chatList, send, lastSlotType } = await this.state;
        await chatList.push({
          agent: false,
          closeStatus: true,
          message: idleMessage,
          name: localStorage.getItem('pixa:agentName'),
          //room: itemData.room,
          send: "",
          type: localStorage.getItem('pixa:agentName'),
          zip: ""
        });
        await this.setState({ chatList: [...chatList], isDisabled: true });
        scrollingElement.scrollTop = scrollingElement.scrollHeight || 0;
      } else {
        idleMessageInterval = setTimeout(async () => {
          const scrollingElement = document.getElementById("scroll-chat");
          const { message, username, chatList, send, lastSlotType } = await this.state;
          await chatList.push({
            agent: false,
            closeStatus: true,
            message: idleMessage,
            name: localStorage.getItem('pixa:agentName'),
            //room: itemData.room,
            send: "",
            type: localStorage.getItem('pixa:agentName'),
            zip: ""
          });
          await this.setState({ chatList: [...chatList], isDisabled: true });
          scrollingElement.scrollTop = scrollingElement.scrollHeight || 0;
        }, 900000);
      }
    }
  }

  tokenCreate = async (date, day) => {
    this.setState({ timeSlotLoader: true });
    date = moment(date).format("YYYY/MM/DD");
    let config1 = await {
      headers: {}
      // {
      //   'cache-control': 'no-cache',
      //   'Content-Type': 'application/json',
      // }
    }
    let requestBody1 = await {
      day: day,
      date: date
    }
    let data = await axios.post(apiUrl, JSON.stringify(requestBody1), config1)
      .then((result) => {
        return result.data;
      })
      .catch((err) => {
        return [];
      })
    this.setState({ bootomScrollButton: false });
    if (data.message) {
      this.setState({ timeSlotLoader: true });
    } else {
      this.setState({ timeSlotLoader: false });
    }
    if (data.data && data.data.available_slots && data.data.available_slots.length > 0) {
      this.setState({ slots: data.data })
      return data.data;
    } else {
      return [];
    }

  }

  callApiForTime = async (token, date, day) => {

  }

  handleChange(e) {
    const { name, value } = e.target;
    this.setState({ [name]: value });
  }

  minimiseChatBox() {
    let { isMinimised } = this.state;
    if (isMinimised) {
      this.setState({ isMinimised: false });
    } else {
      this.setState({ isMinimised: true });
    }
  }

  setUsername = async (message) => {
    await this.setState({ username: message });
    let checkUser = await JSON.parse(localStorage.getItem("user:data"));
    checkUser['username'] = await message;
    localStorage.setItem("user:data", JSON.stringify(checkUser))
  }

  handleButtonSubmit = async (event, storage) => {
    localStorage.setItem('idleMessageInterval', '1');
    if (event) {
      event.persist()
    }
    const { message, username, chatList, send, lastSlotType } = await this.state;
    if (message && message.trim().length > 0) {
      await this.sendMessage({
        action: "sendmessage",
        data: {
          action: 'lex',
          name: username,
          message: message,
          storage: storage,
          send: send,
          type: 'user',
          zip: ""
        }
      });
      // if(storage){
      //   await this.idleMessageset();
      // }
      await this.setState({ message: '', send: '' });
    } else {
      await this.setState({ message: '' });
      ///alert("Message Required!")
    }
  }

  handleSendChatSubmit = async (event, storage) => {
    localStorage.setItem('idleMessageInterval', '1');
    if (event) {
      event.persist()
    }
    const { message, username, chatList, send, lastSlotType } = await this.state;
    let sendMessage = send;
    if (chatList.length === 2) {
      this.setUsername(message);
    }
    if (message && message.trim().length > 0) {
      var text = message.replace(/(<([^>]+)>)/g, "");
      if (lastSlotType) {
        text = text.trim();
        sendMessage = text.replace(/ /g, "77223");
      }
      // if (await !reg.test(message)) {

      // }
      await this.sendMessage({
        action: "sendmessage",
        data: {
          action: 'lex',
          name: username,
          message: text,
          storage: storage,
          send: sendMessage,
          type: 'user',
          zip: ""
        }
      });
      // if(storage){
      //   await this.idleMessageset();
      // }

      await this.setState({ message: '', send: '' });
    } else {
      await this.setState({ message: '' });
      ///alert("Message Required!")
    }
  }

  handleKeypress = async (e) => {
    localStorage.setItem('idleMessageInterval', '1');
    //it triggers by pressing the enter key

    if (e.keyCode === 13) {
      const { message, username, chatList, send, lastSlotType } = await this.state;
      let sendMessage = send;
      if (chatList.length === 2) {
        this.setUsername(message);
      }
      if (message && message.trim().length > 0) {
        //var reg =/<(.|\n)*?>/g; 
        var text = message.replace(/(<([^>]+)>)/g, "");
        if (lastSlotType) {
          text = text.trim();
          sendMessage = text.replace(/ /g, "77223");
        }
        // if (await !reg.test(message)) {

        // }
        await this.sendMessage({
          action: "sendmessage",
          data: {
            action: 'lex',
            name: username,
            message: text,
            storage: true,
            send: sendMessage,
            type: 'user',
            zip: ""
          }
        });

        // await this.idleMessageset();

        await this.setState({ message: '', send: '' });
      } else {
        await this.setState({ message: '' });
        //alert("Message Required!")
      }
    }
  }

  checkisUrl = (s) => {
    var regexp = /(ftp|http|https):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-\/]))?/;
    return regexp.test(s);
  }


  arrangeDates = async (availableDates) => {
    let dates = await availableDates.map(item => item['date']);
    let customFlag = false;
    if (elmnt > 640) {
      customFlag = true;
      this.onDateChange(dates[0]);
    }

    this.setState({ includeDates: dates, selectedDate: customFlag ? dates[0] : '' });
  }



  onDateChange = async (date) => {
    const scrollingElement = document.getElementById("scroll-chat");
    this.setState({ timeSlots: [], showTimeSlot: true, selectedDate: '', selectedTime: '' });
    let returnTime = await this.tokenCreate(new Date(moment(date).format('YYYY/MM/DD')), this.state.daysname[new Date(date).getDay()]);
    const { availableSchedule } = await this.state;
    let selectedDate = await moment(date).format('YYYY/MM/DD');
    let times = await availableSchedule.findIndex(item => moment(item.date).format('YYYY/MM/DD') == selectedDate);
    if (times >= 0) {
      availableSchedule[times].timeSlots = returnTime.available_slots;
      this.setState({ selectedDate: date, availableSchedule: [...availableSchedule], timeSlots: returnTime.available_slots, selectedTime: returnTime.available_slots && returnTime.available_slots.length > 0 ? returnTime.available_slots[0][0] : '' })
    }
    if (scrollingElement) {
      scrollingElement.scrollTop = scrollingElement.scrollHeight || 0;
    }
  }

  onChangeTime = (time, event) => {
    event.persist()
    this.setState({ selectedTime: time })
  }

  convertNumToTime = (number) => {
    // Check sign of given number
    var sign = (number >= 0) ? 1 : -1;

    // Set positive value of number of sign negative
    number = number * sign;

    // Separate the int from the decimal part
    var hour = Math.floor(number);
    var decpart = number - hour;

    var min = 1 / 60;
    // Round to nearest minute
    decpart = min * Math.round(decpart / min);

    var minute = Math.floor(decpart * 60) + '';

    // Add padding if need
    if (minute.length < 2) {
      minute = '0' + minute;
    }
    sign = sign == 1 ? '' : '-';
    let ampm = hour >= 12 ? 'PM' : 'AM';
    hour = hour == 0 ? 12 : hour <= 12 ? hour : hour - 12;
    // Concate hours and minutes
    if (Number(hour) < 10) {
      hour = '0' + hour;
    }
    let time = sign + hour + ':' + minute + ' ' + ampm;
    return time;
  }


  startInit = async (flag) => {
    console.log(webSocket);
    connection = await new WebSocket(webSocket);
    connection.onopen = () => {
      // updateRoomInfo();
      this.setState({ chatList: [] });
      this.sendMessage({
        action: "sendmessage",
        data: {
          action: "init",
          name: "",
          type: "user",
          zip: "",
          room: localStorage.getItem("chat:room") && JSON.parse(localStorage.getItem("chat:room")) ? JSON.parse(localStorage.getItem("chat:room")).room : '',
        }
      });
      // if (localStorage.getItem("chat:room") && JSON.parse(localStorage.getItem("chat:room")) && JSON.parse(localStorage.getItem("chat:room")).room) {
      //   // this.sendMessage({
      //   //   action: "sendmessage",
      //   //   data: {
      //   //     action: 'reqHis',
      //   //     name: '',
      //   //     type: 'agent',
      //   //     zip: "",
      //   //     room: JSON.parse(localStorage.getItem("chat:room")).room,
      //   //     agentID: '',
      //   //   }
      //   // });
      // }
      if (flag) {
        setTimeout(() => {
          // localStorage.setItem('idleMessageInterval', '1');
          this.setState({ message: 'hi' });
          this.handleSendChatSubmit('', false);
        }, 500);
      }
      this.setState({ isDisabled: false });
      // setTimeout(() => {
      //   this.sendMessage({
      //     action: "sendmessage",
      //     data :{
      //       action:'lex',
      //       name:'',
      //       message: 'hi',
      //       //send:'hi',
      //       type: 'user',
      //       zip:"",
      //       room:JSON.parse(localStorage.getItem("chat:room"))?JSON.parse(localStorage.getItem("chat:room")).room:'',
      //     }
      //   });
      // }, 2000);
    };
    connection.onerror = (error) => {
      console.log("WebSocket error", error);
      // if(this.state.startChat){
      //   this.startInit(false);
      // }
      //this.startInit(false);
    };


    connection.onmessage = async (message) => {
      const { chatList, username } = this.state;
      if (message.data.length > 1) {
        const messages = JSON.parse(message.data);
        this.setState({ chatWidth: 330, inputDisabled: false });
        clearInterval(staticMessageInterval);
        if (messages.message === "Internal server error") {
          // alert("route error")

          // chatList.push({
          //   agent: false,
          //   message: 'Please Click on "End Chat" and Start again',
          //   name: localStorage.getItem('pixa:agentName'),
          //   room: "",
          //   send: "",
          //   type: localStorage.getItem('pixa:agentName'),
          //   zip: ""
          // });
          // this.setState({chatList:[...chatList]});
          clearInterval(staticMessageInterval);
          return false;
        }
        let action = messages.type ? messages.type : 'notfound';
        let chatCount = 0;
        const scrollingElement = document.getElementById("scroll-chat");

        switch (action) {
          case "msg":
            if (localStorage.getItem('idleMessageInterval') == '1') {
              clearTimeout(idleMessageInterval);
              this.idleMessageset(false);
            }

            localStorage.setItem("chat:room", JSON.stringify(messages.data[0]));
            chatCount++;
            console.log(messages.data);
            if (messages && messages.data.length > 0 && messages.data[0].responseCard) {
              this.setState({ inputDisabled: true });
            } else {
              this.setState({ inputDisabled: false });
            }
            messages.data = messages.data.sort((a, b) => a.timestamp - b.timestamp);
            if (messages.ignore != 'yes') {
              this.setState({ chatList: [...this.state.chatList, ...messages.data] })
            }
            if (messages && messages.data && messages.data.length > 0 && messages.data[0].message == "Speak Live to an MSL") {
              this.checkAndLoadMessages(messages.data[0], 0);
            }
            //let lastSlotTypeObj = messages.data[0].hasOwnProperty("slotType") && (item.slotType==='slotName' || item.slotType==='slotAvailableName') );
            if (messages && messages.data && messages.data.length > 0 && (messages.data[0].slotType == "slotName" || messages.data[0].slotType == "slotAvailableName")) {
              localStorage.setItem('pixa:agentName', messages.data[0].name);
              this.setState({ lastSlotType: true });
            } else {
              //localStorage.setItem('pixa:agentName', lastSlotTypeObj.name);
              this.setState({ lastSlotType: false });
            }

            var dt = new Date();
            dt.setMinutes(dt.getMinutes() - 15);
            if (messages && messages.data && messages.data.length > 0 && messages.data[messages.data.length - 1].timestamp <= new Date(dt).getTime()) {
              console.log('TimeOut');
              clearTimeout(idleMessageInterval);
              this.idleMessageset(true);
            }

            if (messages && messages.data && messages.data.length > 0 && messages.data[0].assignAgent) {
              clearInterval(staticMessageInterval);
              clearTimeout(idleMessageInterval);
              localStorage.setItem('agentAsign', '1');
              this.setState({ inputDisabled: false });
              this.sendMessage({
                action: "sendmessage",
                data: {
                  action: 'createLink',
                  name: messages.data[0].name,
                  docName: localStorage.getItem("doctor:name") ? localStorage.getItem("doctor:name") : '',
                  type: 'agent',
                  zip: "",
                  room: messages.data[0].room,
                  agentID: messages.data[0].agentID
                }
              });
              //localStorage.removeItem('pixa:agentName');
            }

            let inoutEl = document.getElementById("write_msg");
            if (inoutEl) {
              inoutEl.focus();
            }
            let closeStatus = messages.data.find(item => item.hasOwnProperty("closeStatus") && item.closeStatus);
            // if(messages && messages.data && messages.data.length>0 && messages.data[0].closeStatus){
            if (closeStatus) {
              clearTimeout(idleMessageInterval);
              clearInterval(staticMessageInterval);
              this.setState({ isDisabled: true });
            } else {
              this.setState({ isDisabled: false });
            }


            let docName = messages.data.find(item => item.hasOwnProperty("doctorName") && item.doctorName);
            if (docName) {
              localStorage.setItem("doctor:name", docName.doctorName);
            }
            let slottype = messages.data.find(item => item.slotType == 'slotDate' || item.slotType == 'slotAvailableDate');
            if (slottype) {
              this.setState({ inputDisabled: true });
              let i = 1;

              let d = [];
              let currentDate = new Date().getTime();
              let nowDate = new Date();
              if (currentDate < new Date('2020/12/5 00:00:00').getTime()) {
                nowDate = new Date('2020/12/5 00:00:00');
              }

              if (currentDate < new Date('2020/12/5 00:00:00').getTime()) {
                d.push({ date: new Date('2020/12/05'), timeSlots: [] });
                d.push({ date: new Date('2020/12/06'), timeSlots: [] });
              } else if (currentDate < new Date('2020/12/06 00:00:00').getTime()) {
                //              d.push({ date: new Date('2020-12-05'), timeSlots: [] });
                d.push({ date: new Date('2020/12/06'), timeSlots: [] });
              }
              while (i < 15) {
                let disable = new Date(nowDate.setDate(nowDate.getDate() + 1));
                if (disable.getDay() > 0 && disable.getDay() < 6) {
                  d.push({ date: disable, timeSlots: [] })
                }
                i++
              }

              if (messages.data && messages.data.length > 0 && messages.data[messages.data.length - 1] && (messages.data[messages.data.length - 1].slotType == 'slotDate' || messages.data[messages.data.length - 1].slotType == 'slotAvailableDate')) {
                this.setState({ availableSchedule: d, chatWidth: 530 });
              } else {
                this.setState({ chatWidth: 330 });
              }


              // let slotConfirmBooking = messages.data.find(item => item.slotType == 'slotConfirmBooking');
              // console.log('slotConfirmBooking', slotConfirmBooking);
              // if (slotConfirmBooking) {
              //   this.setState({ chatWidth: 330 });
              // }
              this.arrangeDates(d);

            } else {
              this.setState({ chatWidth: 330 });
            }
            if (scrollingElement) {
              scrollingElement.scrollTop = scrollingElement.scrollHeight || 0;
            }
            break;
          case "link":
            messages.data = messages.data.sort((a, b) => a.timestamp - b.timestamp)
            this.setState({ chatList: [...this.state.chatList, ...messages.data] })
            if (scrollingElement) {
              scrollingElement.scrollTop = scrollingElement.scrollHeight || 0;
            }
            this.setState({ chatWidth: 330 });
            break;
          case "roomData":
            localStorage.setItem("chat:room", JSON.stringify(messages.data));
            this.setState({ chatWidth: 330 });
            //messages.data = messages.data.sort((a, b) => a.timestamp - b.timestamp)
            //this.setState({chatList: [...this.state.chatList, ...messages.data]})
            //scrollingElement.scrollTop = scrollingElement.scrollHeight || 0;
            break;
          case "notaviliable":
            await clearInterval(staticMessageInterval);
            //await localStorage.removeItem('pixa:agentName');
            if (localStorage.getItem('pixa:notaviliable') && localStorage.getItem('pixa:notaviliable') == 'notaviliable') {

            } else {
              localStorage.setItem('pixa:notaviliable', 'notaviliable');
              //await this.setState({ message: 'pixaConnectCloud' });
              await this.sendMessage({
                action: "sendmessage",
                data: {
                  action: 'lex',
                  name: username,
                  storage: false,
                  message: '',
                  send: 'pixaConnectCloud',
                  type: 'user',
                  zip: "",
                  room: localStorage.getItem("chat:room") && JSON.parse(localStorage.getItem("chat:room")) ? JSON.parse(localStorage.getItem("chat:room")).room : '',
                }
              });
            }
            //if(messages && messages.data && messages.data.length>0 && messages.data[0].status=='deny'){

            //}
            // this.sendMessage({
            //   action: "sendmessage",
            //   data :{
            //     action:'lex',
            //     name:'',
            //     message: 'sudarshan',
            //     storage:false,
            //     send:'sudarshan',
            //     type: 'user',
            //     zip:"",
            //     room:JSON.parse(localStorage.getItem("chat:room"))?JSON.parse(localStorage.getItem("chat:room")).room:'',
            //   }
            // });
            //localStorage.setItem("chat:room", JSON.stringify(messages.data));
            this.setState({ chatWidth: 330 });
            break;
          default:
            console.log("Error: unknown action " + action);
            this.setState({ chatWidth: 330 });
        }
      }
    };

    connection.onclose = (evt) => {
      localStorage.removeItem('idleMessageInterval');
      console.log("WebSocket close");
      if (evt.code != 1000 && navigator.onLine) {
        // this.startInit(false);
      }
      if (this.state.startChat && !this.state.isDisabled) {
        this.startInit(false);
      }
    };

  }

  sendMessage = async (message) => {
    if (connection.readyState == 1) {

      const rawMessage = JSON.stringify(message);
      console.log("sendMessage: " + rawMessage);
      connection.send(rawMessage);
    }
  }

  closeChat = async () => {
    const { selectedDate, selectedTime, slots, username } = await this.state;
    await this.sendMessage({
      action: "sendmessage",
      data: {
        action: 'lex',
        name: username,
        storage: false,
        closeStatus: true,
        message: 'Doctor has disconnected. Please close chat.',
        send: '',
        type: 'user',
        zip: "",
        // room: localStorage.getItem("chat:room") && JSON.parse(localStorage.getItem("chat:room")) ? JSON.parse(localStorage.getItem("chat:room")).room : '',
      }
    });
    await connection.close();
    await clearInterval(staticMessageInterval);
    await clearTimeout(idleMessageInterval);
    await localStorage.removeItem('agentAsign');
    await localStorage.removeItem('pixa:agentName');
    await localStorage.removeItem("user:data");
    await localStorage.removeItem("chat:room");
    await localStorage.removeItem("doctor:name");
    await localStorage.removeItem("pixa:notaviliable");
    await localStorage.clear();
    // this.setState({ startChat: false, chatWidth: 330, username: '', chatList: [], isMinimised: false });
    this.setState({ startChat: false, chatWidth: 330, username: '', chatList: [], isDisabled: false, inputDisabled: false });

  }


  closePrompt() {
    let { isPrompt } = this.state;
    if (isPrompt) {
      this.setState({ isPrompt: false });
    } else {
      this.setState({ isPrompt: true });
    }
  }

  openNewTab = async (url) => {
    window.open(url, '_blank');
  }

  async handleSubmit(e) {
    //e.preventDefault();
    await clearInterval(staticMessageInterval);
    await this.setState({ startChat: true });
    await localStorage.removeItem('agentAsign');
    await localStorage.removeItem('pixa:agentName');
    await localStorage.removeItem("user:data");
    await localStorage.removeItem("chat:room");
    await localStorage.removeItem("doctor:name");
    await localStorage.removeItem("pixa:notaviliable");
    await localStorage.clear();
    await localStorage.setItem("user:data", JSON.stringify({ data: "login" }))
    await this.startInit(true);
    // const { username } =await this.state;
    // console.log(this.state)
    // if (username) {
    //   this.setState({startChat:true});
    //   localStorage.setItem("user:data", JSON.stringify({data:"login", username:username}))
    //   this.startInit(username)
    // }else{
    //   alert("Username is required!")
    // }
  }

  arrayEquals = (a, b) => {
    return Array.isArray(a) &&
      Array.isArray(b) &&
      a.length === b.length &&
      a.every((val, index) => val === b[index]);
  }

  remove_common = (fullarray, bookarray) => {
    for (let i = 0; i < fullarray.length; i++) {
      let flag = false;
      for (let j = 0; j < bookarray.length; j++) {
        if (this.arrayEquals(fullarray[i], bookarray[j])) {
          flag = true;
        }
      }
      if (flag) {
        return true;
      }
    }

    return false;

  }

  timeStringToFloat = (time) => {
    var hoursMinutes = time.split(/[.:]/);
    var hours = parseInt(hoursMinutes[0], 10);
    var minutes = hoursMinutes[1] ? parseInt(hoursMinutes[1], 10) : 0;
    return hours + minutes / 60;
  }

  checkAndSetSelected(data, key) {
    let option = data[key + 1];
    if (option) {
      let date = option.message.split(' at ')[0];
      let time = option.message.split(' at ')[1];
      date = new Date(date + ' ' + time);
      if (Object.prototype.toString.call(date) === "[object Date]") {
        // it is a date
        if (isNaN(date.getTime())) {  // d.valueOf() could also work
          // date is not valid
        } else {
          let selectedDate = moment(date).format('YYYY/MM/DD');
          let selectedTime = moment(date).format('hh:mm A');
          // this.setState({selectedDate:selectedDate, selectedTime:selectedTime});
        }
      } else {
        // not a date
      }


    }


  }

  async submitDateTime(event) {
    localStorage.setItem('idleMessageInterval', '1');
    event.persist()
    const { selectedDate, selectedTime, slots, username } = await this.state;
    let that = this;
    let newArray = {};
    let email = '';
    // if(selectedTime.split(' ')[1]=='PM'){
    //   selectedTime = selectedTime.split(':')[0]>12?selectedTime.split(':')[0]+12:selectedTime.split(':')[0]+
    // }
    Object.keys(slots.agent_available_slots).forEach(function (key, index) {
      if (that.remove_common(slots.agent_available_slots[key], [[selectedTime, selectedTime + 0.5]])) {
        newArray[key] = slots.agent_available_slots[key].length;
      }
    }, slots.agent_available_slots);
    if (Object.keys(newArray).length === 1) {
      email = Object.keys(newArray)[0]
    } else {
      email = Object.keys(newArray).sort((prev, next) => next - prev)[0];
    }
    let year = await moment(selectedDate).format('YYYY');
    let month = await moment(selectedDate).format('MM');
    let day = await moment(selectedDate).format('DD');
    /////////
    let newTime = this.convertNumToTime(selectedTime);
    let hour = await Number(newTime.split(':')[0]) < 10 ? newTime.split(':')[0] : newTime.split(':')[0];
    let minuteinit = await newTime.split(':')[1];
    let minute = await minuteinit.split(' ')[0];
    let ampm = await minuteinit.split(' ')[1];
    let finalString = year + '' + month + '' + day + '' + hour + '' + minute + '' + ampm + '.+.' + email;

    // moment(this.state.selectedDate).format('YYYY')+''+moment(this.state.selectedDate).format('MM')+''+moment(this.state.selectedDate).format('DD')+''+moment(this.state.selectedTime).format('hh')+''+moment(this.state.selectedTime).format('mm')+''+moment(this.state.selectedTime).format('A')
    await this.setState({ message: moment(this.state.selectedDate).format('dddd, MMMM DD') + ' at ' + newTime, send: finalString });
    await this.sendMessage({
      action: "sendmessage",
      data: {
        action: 'lex',
        name: username,
        storage: true,
        message: moment(this.state.selectedDate).format('dddd, MMMM DD') + ', at ' + newTime.split(' ')[0] + ' <span style="font-size:9px;font-weight: 700;">' + newTime.split(' ')[1] + '</span>',
        send: finalString,
        requestusername: true,
        type: 'user',
        zip: "",
        room: localStorage.getItem("chat:room") && JSON.parse(localStorage.getItem("chat:room")) ? JSON.parse(localStorage.getItem("chat:room")).room : '',
      }
    }); //this.handleSendChatSubmit(e, true);
    await this.setState({ message: '', send: '', inputDisabled: false });
  }

  setWidth = () => {
    // if(this.state.chatWidth===530){
    //   this.setState({chatWidth:330});
    // }
    return null
  }

  scrollTimeSlot = (flag, haxId) => {
    const currentLocation = document.getElementById(haxId).scrollTop;
    // if(document.getElementById(haxId).scrollTop>=document.getElementById(haxId).scrollHeight){
    //   this.setState({isEnd:true});
    // }
    if (flag === 'up') {
      document.getElementById(haxId).scrollTop = currentLocation - 50;

    } else {
      document.getElementById(haxId).scrollTop = currentLocation + 50;
    }
  }

  checkArrowDisabled = (flag, haxId) => {

    //const currentLocation = document.getElementById(haxId).scrollTop;
    //console.log(currentLocation);
    // console.log(document.getElementById(haxId));
    // if(currentLocation<=0 && flag=='up'){
    //   return true;
    // }if(currentLocation>0  && flag=='down'){
    //   return true;
    // }else{
    //   return false;
    // }
    return false;
  }


  checkAndLoadMessages = (itemData, index) => {
    const { chatList } = this.state;
    //this.setState({isDisabled:true});
    let msg = IntervalMessages;
    const scrollingElement = document.getElementById("scroll-chat");
    let that = this;
    if (index == 0) {
      chatList.push({
        agent: false,
        message: msg[0],
        name: localStorage.getItem('pixa:agentName'),
        room: itemData.room,
        send: "",
        type: localStorage.getItem('pixa:agentName'),
        zip: ""
      });
      this.setState({ chatList: [...chatList], inputDisabled: true });
      scrollingElement.scrollTop = scrollingElement.scrollHeight || 0;
      clearInterval(staticMessageInterval);
      setTimeout(() => {
        clearInterval(staticMessageInterval);
      }, 300000);
      staticMessageInterval = setInterval(() => {
        //staticMessageIndex
        if (staticMessageIndex == 1) {
          chatList.push({
            agent: false,
            message: msg[staticMessageIndex],
            name: localStorage.getItem('pixa:agentName'),
            room: itemData.room,
            send: "",
            type: localStorage.getItem('pixa:agentName'),
            zip: ""
          });
          that.setState({ chatList: [...chatList] });
          staticMessageIndex = 2;
        } else {
          chatList.push({
            agent: false,
            message: msg[staticMessageIndex],
            name: localStorage.getItem('pixa:agentName'),
            room: itemData.room,
            send: "",
            type: localStorage.getItem('pixa:agentName'),
            zip: ""
          });
          that.setState({ chatList: [...chatList] });
          staticMessageIndex = 1;
        }
        scrollingElement.scrollTop = scrollingElement.scrollHeight || 0;
      }, 20000);
    }
  }

  onScrollEvent = (event, haxid) => {
    let el = document.getElementById(haxid);
    if ((el.offsetHeight + el.scrollTop + 1) >= el.scrollHeight) {
      this.setState({ bootomScrollButton: true });
    } else {
      this.setState({ bootomScrollButton: false });
    }
    if (el.scrollTop == 0) {
      this.setState({ topScrollButton: true });
    } else {
      this.setState({ topScrollButton: false });
    }
  }

  checkdisabled = (slotType, buttonValue, index) => {
    const { chatList } = this.state;
    //let slotIndex = chatList.findIndex(item=>item.hasOwnProperty("slotType") && item.slotType == slotType);
    //console.log("slotIndex", slotIndex, "chatList[slotIndex+1]", chatList[slotIndex+1], "index", index)
    //if(slotIndex >= 0 && slotIndex==index){
    //console.log("slotIndex exist");
    // if(chatList[slotIndex+1] && chatList[slotIndex+1].send == buttonValue) {
    if (chatList[index + 1]) {
      return true;
    } else return false;
    //} else return false
  }

  checkdisabledDatePicker = (slotType, buttonValue, index) => {
    const { chatList } = this.state;
    let slotIndex = chatList.findIndex(item => item.hasOwnProperty("slotType") && item.slotType == slotType);
    if (slotIndex >= 0) {
      if (chatList[slotIndex + 1] && chatList[slotIndex + 1].send == buttonValue) {
        return true;
      } else return false;
    } else return false
  }

  checkTimeSlotHeight = (haxid) => {
    let el = document.getElementById(haxid);

    if (el) {
      //  el.scrollTop = el.scrollTop+1;
      if (el.scrollHeight >= el.offsetHeight) {
        return false;
      } else {
        return true;
      }
    } else {
      return true;
    }
  }


  render() {
    // const { username, startChat, message, chatList, isMinimised, chatWidth, showTimeSlot, timeSlotLoader } = this.state;
    const { username, startChat, message, chatList, chatWidth, showTimeSlot, timeSlotLoader, isPrompt, inputDisabled } = this.state;


    return (
      <div>
        {
          startChat ?
            <div>
              {/* <h2 style={{textAlign: 'center', paddingTop: "10px"}}> Pixa Chat <span onClick={() => this.closeChat()} className="span-close">Close chat</span></h2> */}
              {/* <div className="pcc-container"> */}
              <div>
                <div className="mesgs chat-box-container" style={{ width: chatWidth ? chatWidth : 330 }}>
                  {/* <div className="mesgs chat-box-container" style={{ width: chatWidth ? chatWidth : 330, bottom: `${isMinimised ? '-15px' : '0px'}` }}> */}
                  <div className="chat-box">
                    <div className="chat-box-header" onClick={() => this.minimiseChatBox()}>
                      {/* <ReactSVG src="pcc-logo-blue.svg"/> */}
                      <img src={this.state.logoWhiteBase64} className="adc-white-logo" />
                      {/* <img src={require('./pcc-logo-blue.png')} className="pcc-blue-logo" /> */}
                      {/* <img src={require('./adc-white.png')} className="adc-white-logo" /> */}
                      {/* <ReactSVG src={`${isMinimised ? 'minimise.svg': 'close.svg'}`} className="close-btn" onClick={() => this.minimiseChatBox()}/> */}
                      <img src={require(imagesPath + 'close-btn.png')} className="close-btn" onClick={() => this.closeChat()} />
                      {/* <img src={`${isMinimised ? require('./dash.png') : require('./close-btn.png')}`} className={`${isMinimised ? "dash-btn" : "close-btn"}`} onClick={isMinimised ? () => this.minimiseChatBox() : () => this.closeChat()} /> */}
                    </div>
                    <div className="msg_history" id="scroll-chat">
                      {/* <div className="msg_history" id="scroll-chat" style={{ display: `${isMinimised ? 'none' : 'block'}` }}> */}
                      {
                        chatList.length > 0 ?
                          <div className="incoming_msg">
                            <div className="received_msg">
                              {
                                chatList.map((item, key) => (
                                  <div key={key} className={`received_withd_msg ${item.type === `user` ? "me" : "contact"}`} ref={(el) => { this.messagesEnd = el; }}>
                                    {/* <span className="name-timestamp"><span className="name">{item.name}</span> <span className="time_date"> { new Date(item.timestamp).toLocaleDateString("en-US")}</span></span> */}
                                    <span className="name-timestamp">
                                      {
                                        item.type !== 'user' ? <span className="name">{item.name}</span> : null
                                      }
                                      <span className="time_date"> {moment(item.timestamp).format('DD/MM/YYYY,hh:mm')}</span></span>

                                    <span className="message-text">
                                      {
                                        item.message && this.checkisUrl(item.message) ? <a style={{ color: '#007bff', cursor: 'pointer' }} onClick={() => this.openNewTab(item.message)}>{item.message}</a> : ReactHtmlParser(item.message)}
                                      {
                                        item.responseCard && item.slotType === 'slotSpeakSchedule' || item.slotType === 'slotAvailable' || item.slotType === 'slotisAvailable' ?
                                          <div className="response-card" >
                                            {
                                              item.responseCard.genericAttachments && item.responseCard.genericAttachments.length > 0 ?
                                                item.responseCard.genericAttachments[0].buttons.map((itemButton, i) => (
                                                  <button key={'button-' + i} disabled={this.checkdisabled(item.slotType, itemButton.value, key)} className="response-btn-outlinne" onClick={async (e) => {
                                                    await this.setState({ message: itemButton.text, send: itemButton.value });
                                                    await this.handleButtonSubmit(e, true);
                                                  }} >{itemButton.text}</button>
                                                ))
                                                : null
                                            }
                                          </div>
                                          : null
                                      }

                                      {
                                        item.responseCard && item.slotType === 'slotConfirmBooking' || item.slotType === 'slotAvailableConfirmBooking' ?
                                          <div className="response-card response-card-3" >
                                            {
                                              item.responseCard.genericAttachments && item.responseCard.genericAttachments.length > 0 ?
                                                item.responseCard.genericAttachments[0].buttons.map((itemButton, i) => (
                                                  <button key={'button-' + i} disabled={this.checkdisabled(item.slotType, itemButton.value, key)} className={i == 0 ? 'response-btn-outlinne' : 'response-btn-clear'} onClick={async (e) => {
                                                    await this.setState({ message: itemButton.text, send: itemButton.value });
                                                    await this.handleButtonSubmit(e, true);

                                                  }} >{itemButton.text}</button>
                                                ))
                                                : null
                                            }
                                          </div>
                                          : null
                                      }
                                    </span>

                                    {/* {
                                  item.responseCard && (item.slotType === 'slotDate' || item.slotType === 'slotTime') ?
                                    <div className="response-card-1" >
                                      {
                                        item.responseCard.genericAttachments && item.responseCard.genericAttachments.length > 0 ?
                                          item.responseCard.genericAttachments[0].buttons.map((itemButton, i) => (
                                            <button key={'button-' + i} className="response-btn-outlinne" onClick={async (e) => {
                                              await this.setState({ message: itemButton.value });
                                              await this.handleSendChatSubmit(e);
                                            }} >{itemButton.text}</button>
                                          ))
                                          : null
                                      }
                                    </div>
                                    : null
                                } */}


                                    {
                                      item.responseCard && (item.slotType === 'slotDate' || item.slotType === 'slotTime') || item.slotType === 'slotAvailableDate' ?

                                        <div className="response-card-2" >
                                          {
                                            this.checkAndSetSelected(chatList, key)
                                          }
                                          {/* {
                                              item.responseCard.genericAttachments && item.responseCard.genericAttachments.length>0?
                                                item.responseCard.genericAttachments[0].buttons.map((itemButton, i)=>(
                                                  <button key={'button-'+i} className="response-btn-outlinne" onClick={async(e)=>{
                                                    await this.setState({message: itemButton.value });
                                                    await this.handleSendChatSubmit(e);
                                                  }} >{itemButton.text}</button>
                                                ))
                                              :null
                                            } */}
                                          <div className="response-card-2_section">
                                            <div className="picker date-picker">
                                              <DatePicker
                                                selected={this.state.selectedDate}
                                                //showTimeSelect={true}
                                                onChange={date => this.onDateChange(date)}
                                                includeDates={this.state.includeDates}
                                                formatWeekDay={nameOfDay => nameOfDay.substr(0, 3)}
                                                // includeTimes={[
                                                //   new Date().setHours(new Date().setMinutes(new Date(), 0), 17),
                                                //   new Date().setHours(new Date().setMinutes(new Date(), 30), 18),
                                                //   new Date().setHours(new Date().setMinutes(new Date(), 30), 19),
                                                //   new Date().setHours(new Date().setMinutes(new Date(), 30), 17)
                                                // ]}
                                                inline
                                              />
                                            </div>
                                            {
                                              showTimeSlot ?
                                                <div className="picker time-picker">
                                                  <div className="timeslots" id={'timeSlot-' + key} onScroll={(e) => this.onScrollEvent(e, 'timeSlot-' + key)}>
                                                    <a className="timebackbutton" onClick={(e) => this.setState({ showTimeSlot: false, selectedDate: '' })}>
                                                      <img src={require(imagesPath + 'back.png')} />
                                                      <span>{BackToCalendar}</span>
                                                    </a>

                                                    {
                                                      this.state.timeSlots && this.state.timeSlots.length > 0 ?
                                                        this.state.timeSlots.map((item, i) => (
                                                          <button key={'timeButton-' + i} className="time-button" style={item[0] === this.state.selectedTime ? { backgroundImage: 'linear-gradient(to right, #153ba6 , #0580b9)', borderColor: '#153ba6', color: '#fff' } : null} onClick={(e) => this.onChangeTime(item[0], e)} >{this.convertNumToTime(item[0]).split(' ')[0]} <span>{this.convertNumToTime(item[0]).split(' ')[1]}</span></button>
                                                        ))
                                                        : timeSlotLoader ? <div className="loaderContainer"><img className="loaderGif" src={loader} /></div> : <div className="loaderContainer"><p className="noslots">{noSlotsMsg}</p></div>
                                                    }
                                                  </div>
                                                  {
                                                    this.state.timeSlots && this.state.timeSlots.length > 5 ?
                                                      <div className="time-controll">
                                                        <button disabled={this.state.topScrollButton} onClick={(e) => this.scrollTimeSlot('up', 'timeSlot-' + key)} className="time-controll-item up">
                                                          <img src={require(imagesPath + 'up.png')} />
                                                        </button>
                                                        <button disabled={this.state.bootomScrollButton || this.checkTimeSlotHeight('timeSlot-' + key)} onClick={(e) => this.scrollTimeSlot('down', 'timeSlot-' + key)} className="time-controll-item down">
                                                          <img src={require(imagesPath + 'down.png')} />
                                                        </button>
                                                      </div>
                                                      : null
                                                  }

                                                </div>
                                                : null
                                            }
                                          </div>
                                          <div className="selectedDateButton" style={{ visibility: this.state.timeSlots && this.state.timeSlots.length > 0 ? 'visible' : 'hidden' }}>
                                            {this.state.selectedDate ? <button type="button" disabled={this.state.selectedDate === '' || this.state.selectedTime === '' || this.checkdisabled(item.slotType, this.state.selectedDate, key)} className="response-btn-outlinne" onClick={(e) => this.submitDateTime(e)}  > {'Select ' + moment(this.state.selectedDate).format('dddd, MMMM DD') + ', at '} <span style={{ display: 'inline-block' }}> {this.convertNumToTime(this.state.selectedTime).split(' ')[0]} <span className="supper">{this.convertNumToTime(this.state.selectedTime).split(' ')[1]}</span></span>
                                            </button> : <button type="button" disabled={true} className="response-btn-outlinne">{selectDateMsg}</button>}
                                          </div>

                                        </div>
                                        : this.setWidth()
                                    }

                                  </div>
                                ))
                              }
                            </div>
                          </div>
                          : <div className="loaderContainer"><img className="loaderGifScreen" src={loader} /></div>
                      }
                    </div>
                    {this.state.isDisabled ?
                      (<div onClick={() => this.closeChat()} className="end-chat">
                        {/* ( <div onClick={() => this.closeChat()} className="end-chat" style={{ display: `${isMinimised ?  'none' : this.state.isDisabled ? 'block' : 'none'}` }}> */}
                        <span>{END_CHAT}</span>
                        <img src={require(imagesPath + 'arrow.png')} className="arrow" />
                      </div>)
                      :
                      (<div className="type_msg">
                        {/* <div className="type_msg" style={{ display: `${isMinimised ? 'none' : 'block'}` }}> */}
                        {/* onKeyDown={(e) =>this.handleSendChatSubmit(e)} */}
                        <div className="input_msg_write">
                          {/* <div className="input_msg_write" style={{ display: `${isMinimised ? 'none' : 'block'}` }}> */}
                          <input type="text" disabled={inputDisabled} className="write_msg" id="write_msg" name="message" autoComplete="off" value={message} onChange={this.handleChange} onKeyDown={this.handleKeypress} placeholder="Type a message" />
                          {/* <button className="msg_send_btn" onClick={(e) =>this.handleSendChatSubmit(e)} type="button">Send</button> */}
                          {/* <ReactSVG  src="send.svg" className="msg_send_btn" onClick={(e) =>this.handleSendChatSubmit(e)} /> */}
                          <img src={require(imagesPath + 'send.png')} className="msg_send_btn" onClick={(e) => this.handleSendChatSubmit(e, true)} />
                        </div>
                      </div>
                      )}

                  </div>
                </div>
              </div>
            </div>
            :
            // <div className="container">
            <div>
              <div className="chat-input-box" style={{ display: `${isPrompt ? 'none' : 'block'}` }}>
                <div className="chat-input-container">
                  <div style={{ textAlign: "center", marginBottom: 20 }}>
                    <img src={this.state.logoBase64} className="adc-logo" />
                    <img src={require(imagesPath + 'close-btn-dark.png')} className="close-btn" onClick={() => this.closePrompt()} />
                    {/* <img src={require('./adc-logo.png')} className="adc-logo" /> */}
                  </div>
                  <p className="chat-info">{ReactHtmlParser(WelcomeTexts[0])}</p>
                  <p className="chat-info">{ReactHtmlParser(WelcomeTexts[1])}</p>
                  <p className="chat-info">{ReactHtmlParser(WelcomeTexts[2])}</p>
                  <p className="chat-info fs-10">{ReactHtmlParser(WelcomeTexts[3])}</p>
                </div>
                <div className="continue-btn">
                  <button className="start-chat-btn" onClick={(e) => this.handleSubmit(e)} >{CONTINUE}
                    <img src={require(imagesPath + 'arrow.png')} className="arrow" />
                  </button>
                </div>
              </div>
            </div>

        }
      </div>
    );
  }
}